import styled from 'styled-components'

import { _2XL_Bold, _S_Normal, mainColors } from '@avantstay/backoffice-core'

// Styles shared by the panel's views (loading, session gate, chat empty
// state). Chat-specific and session-picker styles live next to their
// components; the common chat language (bubbles, input bar) comes from
// @new/__ui/AIChat.

// Panel title row: keeps the BetaBadge (a flex div) on one line with the text
// inside AttachmentBar's h2 title.
export const TitleWithBadge = styled.span`
  display: inline-flex;
  align-items: center;
`

// Mount point that adopts the persistent chat host on each panel open; both it
// and the host are `display: contents` so the chat views keep laying out as
// direct flex children of the panel container.
export const ChatHostSlot = styled.div`
  display: contents;
`

// Full-height centered container for the loader, the continue/new gate and the
// chat empty state.
export const Centered = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  gap: 10px;
  padding: 40px 28px;
`

// 56px round Remy icon badge used by the gate and the chat empty state.
export const IconBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #dbeafe;
  color: #1d4ed8;
  margin-bottom: 4px;
`

export const PanelTitle = styled.div`
  ${_2XL_Bold}
  color: ${mainColors.primaryMedium};
`

export const PanelText = styled.p`
  ${_S_Normal}
  max-width: 340px;
  line-height: 1.5;
  color: ${mainColors.neutralExtraDark};
`
